import { canAccess } from "../../Services/Auth/Authentification";
import { Navigate } from "react-router-dom";
import CanauxList from "./CanauxList";
const Canaux = (props) =>{
    let permNeeded = props.permNeeded;
    

    if(!canAccess(permNeeded)){
        return(
            <Navigate to={"/"}/>
        )
    }else{
        

        
        return(<>
        
            <h1>Liste des Canaux</h1>
            <hr></hr>
            <CanauxList togglesnack={props.togglesnack}/>
        </>)
    }
}

export default Canaux;